document.addEventListener("DOMContentLoaded", function () {
  // Select all `.resource--item` elements from all `.w-dyn-list` containers
  const allItems = Array.from(document.querySelectorAll(".resource--item"));

  // Parse the date from the `<p>` inside `.recipe-text`
  const itemsWithDates = allItems.map((item) => {
    const dateText = item.querySelector(".recipe-text p").textContent.trim(); // Get the date text
    const date = new Date(dateText); // Convert the "August 13, 2024" text to a Date object
    return { element: item, date };
  });

  // Sort items by date (newest first)
  itemsWithDates.sort((a, b) => b.date - a.date);

  // Find the first `.grid--4cl` container
  const mainContainer = document.querySelector(".grid--4cl");

  // Clear the first container to prepare for merged and sorted items
  mainContainer.innerHTML = "";

  // Append sorted items to the first container
  itemsWithDates.forEach(({ element }) => {
    mainContainer.appendChild(element);
  });

  // Remove other `.w-dyn-list` containers except the first one
  const allLists = document.querySelectorAll(".w-dyn-list");
  allLists.forEach((list, index) => {
    if (index > 0) {
      list.remove();
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("searchInput");
  const radioButtons = document.querySelectorAll('input[name="tagFilter"]');
  const resourceItems = document.querySelectorAll(".resource--item");
  const categoryLabels = document.querySelectorAll(".category-label"); // Target the labels

  function filterItems() {
    const searchTerm = searchInput ? searchInput.value.toLowerCase() : ""; // Handle no search input
    const selectedRadio = document.querySelector(
      'input[name="tagFilter"]:checked'
    );
    const selectedTag = selectedRadio
      ? selectedRadio.value.toLowerCase()
      : "all";

    let visibleItems = [];
    resourceItems.forEach((item) => {
      const headingElement = item.querySelector(".heading--20");
      const tagElement = item.querySelector(".tags-wrapper .tag");

      const heading = headingElement
        ? headingElement.textContent.toLowerCase()
        : "";
      const tag = tagElement ? tagElement.textContent.toLowerCase() : "";

      const matchesSearch =
        heading.includes(searchTerm) || tag.includes(searchTerm);
      const matchesTag = selectedTag === "all" || tag === selectedTag;

      if (matchesSearch && matchesTag) {
        item.style.display = "block";
        visibleItems.push(item);
      } else {
        item.style.display = "none";
        item.classList.remove("first-visible-item", "eighth-visible-item");
      }
    });

    visibleItems.forEach((item, index) => {
      item.classList.remove("first-visible-item", "eighth-visible-item");
      if (index === 0) item.classList.add("first-visible-item");
      if (index === 7) item.classList.add("eighth-visible-item");
    });

    // Update active class on category labels
    categoryLabels.forEach((label) => {
      const radioInput = label.querySelector('input[name="tagFilter"]');
      if (radioInput && radioInput.checked) {
        label.classList.add("is--active");
      } else {
        label.classList.remove("is--active");
      }
    });
  }

  if (searchInput) {
    searchInput.addEventListener("input", filterItems);
  }
  radioButtons.forEach((button) => {
    button.addEventListener("change", filterItems);
  });

  filterItems(); // Initial call
});
